import { DacResponse } from '@/types';
import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../components/data-table-builder/data-table.types';
import { Observable } from 'rxjs';

interface getDacDataTableStructureProps {
  rowActionsFn?: (target: DacResponse) => DataTableRowActions;
  createAction?: () => void;
  createActionDisabled?: Observable<boolean>;
}

export const getDacDataTableStructure = ({ rowActionsFn, createAction, createActionDisabled }: getDacDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dac.table.ref',
    accessorKey: 'reference',
    variant: DataTableColumnVariant.TEXT,
  };

  const dacStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dac.table.dacStep',
    accessorKey: 'etapeDac',
    variant: DataTableColumnVariant.TEXT,
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dac.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const marketTypeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'dac.table.marketType',
    accessorKey: 'realisation.typeMarcher.description',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'dac.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: `ppm.status.${value}` };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'dac.table.created_at',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'dac.table.updated_at',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'dac.singular',
    plural: 'dac.plural',
    columns: [idColumn, dacStepColumn, marketTypeColumn, statusColumn, processStepColumn, createdAtColumn, updatedAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    createAction,
    createActionDisabled,
    rowActionsFn,
    searchableFields: ['dacId'],
  };
};
